import { render, staticRenderFns } from "./AlterarDetentorItemAditivoApostila.vue?vue&type=template&id=60a8d924"
import script from "./AlterarDetentorItemAditivoApostila.vue?vue&type=script&lang=js"
export * from "./AlterarDetentorItemAditivoApostila.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports